module.exports = __webpack_public_path__ + "media/configurations/P-X-X-X-X-P-9f93e1eb.png";